<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'cardoverbg',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <div class="bg-layer">
      <a-row :gutter="[-1,-1]" style="z-index: 100;position: relative;">
        <a-col class="content-box padding" @mouseover="mo(i)" @mouseout="mt" :sm="getCol.sm(data.col)" :md="getCol.md(data.col)"  :lg="getCol.lg(data.col)"  v-for="(item,i) in data.child" :key="i">

              <h3 class="flex align-center justify-center">
                <span class="flex1">{{ item.name }}</span>
                <a v-if="item.url">
                      <ArrowRightOutlined />
                </a>
              </h3>
              <h5 v-if="item.sub">{{ item.sub }}</h5>

        </a-col>
      </a-row>
        <div class="bg-img" :class="i==def?'active':''" v-for="(item,i) in data.child" :key="i" :style="{backgroundImage:'url('+addip(item.pic)+')'}">
        </div>
      </div>
    </div>
</template>
<script setup lang="ts" name="cardoverbg">
import {defineComponent,defineProps, onMounted,ref } from 'vue'
import {addip,getCol} from '@/utils/util'
import {ArrowRightOutlined} from '@ant-design/icons-vue'
const def=ref<Number>(0)
const props=defineProps({
  data:Object
})
onMounted(()=>{
  mt()
})
const mo=(i:Number)=>{
  def.value=i
}
const mt=()=>{
  def.value=0
}
</script>
<style lang="less">
@import '@/style/main.less';
  .cardoverbg{
    .bg-layer{
      position: relative;
      .bg-img{position: absolute;left:0;top:0;width:100%;height:100%;z-index: 0;transition: all .3s linear;transform: scaleY(0);transform-origin: center 100%;}
      .bg-img.active{transform: scaleY(1);}
    }

    .content-box{
      height: 196px;overflow: hidden;box-shadow: @white-opacity-50 0 0 1.5px;color: @white;
    }
    .content-box:hover{transform: translateY(0);
      background-color:@primary-opacity-50;backdrop-filter: blur(10px);
    }
  }
</style>
